import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  text: {
    textAlign: 'inherit',
    fontWeight: 'inherit'
  },

  date: {
    fontWeight: 'inherit',
    color: 'inherit'
  },

  mb12: {
    marginBottom: 12
  },

  buttonLink: {
    padding: 0,
    fontWeight: 'inherit',
    fontSize: 'inherit',
    '&>*': {
      fontWeight: 'inherit',
      fontSize: 'inherit'
    }
  }
}))
